export const initialReportSettings = {
  reportName: '',
};

export const initialErrors = {
  reportName: { hasError: false, errorText: '' },
};
